import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

const sendEmailVerificationZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("SEND_EMAIL_VERIFICATION_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    emailAddress: z.string().email(),
});

type SendEmailVerificationCommand = z.infer<
    typeof sendEmailVerificationZodObject
>;
const sendEmailVerificationZodSchema: z.ZodSchema<SendEmailVerificationCommand> =
    sendEmailVerificationZodObject;

type FactoryParams = Except<
    SendEmailVerificationCommand,
    "_id" | "_type" | "_createdAt"
>;
const sendEmailVerificationCommandFactory = (
    params: FactoryParams,
): SendEmailVerificationCommand => {
    const command = {
        _id: generateId({ prefix: "send_verification_email_command__" }),
        _type: "SEND_EMAIL_VERIFICATION_COMMAND" as const,
        _createdAt: nowIsoAndUnix(),
        emailAddress: params.emailAddress,
    };
    return command;
};

export {
    sendEmailVerificationCommandFactory,
    sendEmailVerificationZodObject,
    sendEmailVerificationZodSchema,
};
export type {
    SendEmailVerificationCommand,
    FactoryParams as SendEmailVerificationCommandFactoryParams,
};
